import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query Courses($page: Int, $perPage: Int, $search: String, $status: StatusEnum) {
    Courses(page: $page, perPage: $perPage, search: $search, status: $status) {
      items {
        id
        name
        active
        courseGroup {
          category {
            name
          }
        }
        modality {
          name
        }
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  name: string;
  active: boolean;
  modality: {
    name: string;
  };
  courseGroup: {
    category: {
      name: string;
    };
  };
}

export interface GetAllGql {
  Courses: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
